module.exports = __webpack_public_path__ + "wasserknapp3.326af3a5496bb8c8c5805c0ca2fb24a9.png";